export default __webpack_public_path__ + "static/Years1991_B-252x120-0423b450a2079a4a47b7a958c9895e02.jpeg";